<template>
  <div class="table-tab u-indent-m-b-45px">
    <div class="a-flex-space-between a-align-items-flex-end u-margin-b-24">
      <h3 class="u-font-size-22 u-color-black u-width-auto u-margin-0">{{$t('form.reports.registry-of-procedures-by-stages.title')}}</h3>
      <button class="gui-btn gui-btn--red gui-btn--w-150" @click.prevent="$emit('export')">
        {{$t('buttons.export')}}
      </button>
    </div>
    <section v-maximizable>
      <div class="table-tab__container" style="overflow: auto; outline: none;">
      <table class="table-tab__block table" style="width: 2300px"  v-columns-resizable>
        <thead class="table-tab__thead">
        <tr class="">
          <th class="table-tab__border-right ">
            {{$t('form.reports.registry-of-procedures-by-stages.column.lot-name')}}
          </th>
          <th class="table-tab__border-right">
            {{$t('form.reports.registry-of-procedures-by-stages.column.originator')}}
          </th>
          <th class="table-tab__border-right">
            {{$t('form.reports.registry-of-procedures-by-stages.column.owner-department')}}
          </th>
          <th class="table-tab__border-right">
            {{$t('form.reports.registry-of-procedures-by-stages.column.owner')}}
          </th>
          <th class="table-tab__border-right " colspan="3">
            {{$t('form.reports.registry-of-procedures-by-stages.column.purchase-procedure')}}
          </th>
          <th class="table-tab__border-right ">
            {{$t('form.reports.registry-of-procedures-by-stages.column.purchase-task-number')}}
          </th>
          <th class="table-tab__border-right table-tab__border-bottom" colspan="10">
            {{$t('form.reports.registry-of-procedures-by-stages.column.tender-stages')}}
          </th>
          <th class="table-tab__border-right">
            {{$t('form.reports.registry-of-procedures-by-stages.column.winner')}}
          </th>
          <th class="table-tab__border-right">
            {{$t('form.reports.registry-of-procedures-by-stages.column.acceptance-price')}}
          </th>
          <th>
            {{$t('form.reports.registry-of-procedures-by-stages.column.acceptance-currency')}}
          </th>
        </tr>
        <tr class="">
          <th class="table-tab__border-right">

          </th>
          <th class="table-tab__border-right">

          </th>
          <th class="table-tab__border-right ">

          </th>
          <th class="table-tab__border-right">

          </th>
          <th colspan="2">

          </th>
          <th class="table-tab__border-right">

          </th>
          <th class="table-tab__border-right " >

          </th>

          <th class="table-tab__border-right " colspan="2">
            {{$t('form.reports.registry-of-procedures-by-stages.column.tender-stages-tender-duration')}}
          </th>
          <th class="table-tab__border-right " colspan="2">
            {{$t('form.reports.registry-of-procedures-by-stages.column.tender-stages-proposals-submission')}}
          </th>
          <th class="table-tab__border-right " colspan="2">
            {{$t('form.reports.registry-of-procedures-by-stages.column.tender-stages-admittance')}}
          </th>
          <th class="table-tab__border-right " colspan="2">
            {{$t('form.reports.registry-of-procedures-by-stages.column.tender-stages-clarification')}}
          </th>
          <th class="table-tab__border-right " colspan="2">
            {{$t('form.reports.registry-of-procedures-by-stages.column.tender-stages-results')}}
          </th>
          <th class="table-tab__border-right ">

          </th>
          <th class="table-tab__border-right ">

          </th>
          <th>

          </th>
        </tr>
        <tr class="">
          <th class="table-tab__border-right">

          </th>
          <th class="table-tab__border-right">

          </th>
          <th class="table-tab__border-right ">

          </th>
          <th class="table-tab__border-right">

          </th>
          <th class="table-tab__border-right table-tab__border-top">
            {{$t('form.reports.registry-of-procedures-by-stages.column.purchase-procedure-type')}}
          </th>
          <th class="table-tab__border-right table-tab__border-top">
            {{$t('form.reports.registry-of-procedures-by-stages.column.purchase-procedure-tender-number')}}
          </th>
          <th class="table-tab__border-right table-tab__border-top">
            {{$t('form.reports.registry-of-procedures-by-stages.column.purchase-procedure-lot-number')}}
          </th>
          <th class="table-tab__border-right ">

          </th>
          <th class="table-tab__border-right table-tab__border-top">
            {{$t('form.reports.registry-of-procedures-by-stages.column.tender-stages-planned-duration')}}
          </th>
          <th class="table-tab__border-right table-tab__border-top">
            {{$t('form.reports.registry-of-procedures-by-stages.column.tender-stages-actual-duration')}}
          </th>
          <th class="table-tab__border-right table-tab__border-top">
            {{$t('form.reports.registry-of-procedures-by-stages.column.tender-stages-planned-duration')}}
          </th>
          <th class="table-tab__border-right table-tab__border-top">
            {{$t('form.reports.registry-of-procedures-by-stages.column.tender-stages-actual-duration')}}
          </th>
          <th class="table-tab__border-right table-tab__border-top">
            {{$t('form.reports.registry-of-procedures-by-stages.column.tender-stages-planned-duration')}}
          </th>
          <th class="table-tab__border-right table-tab__border-top">
            {{$t('form.reports.registry-of-procedures-by-stages.column.tender-stages-actual-duration')}}
          </th>
          <th class="table-tab__border-right table-tab__border-top">
            {{$t('form.reports.registry-of-procedures-by-stages.column.tender-stages-planned-duration')}}
          </th>
          <th class="table-tab__border-right table-tab__border-top">
            {{$t('form.reports.registry-of-procedures-by-stages.column.tender-stages-actual-duration')}}
          </th>
          <th class="table-tab__border-right table-tab__border-top">
            {{$t('form.reports.registry-of-procedures-by-stages.column.tender-stages-planned-duration')}}
          </th>
          <th class="table-tab__border-right table-tab__border-top">
            {{$t('form.reports.registry-of-procedures-by-stages.column.tender-stages-actual-duration')}}
          </th>
          <th class="table-tab__border-right ">

          </th>
          <th class="table-tab__border-right ">

          </th>
          <th>

          </th>
        </tr>
        </thead>
        <tbody class="table-tab__tbody">
        <template v-for="(row, rowIdx) in report">
          <tr :class="{'table-tab__background-color': rowIdx % 2}"
              v-for="(bid, idx) in (row.bids && row.bids.length > 0 ? row.bids : [{}])">
            <template v-if="idx === 0">
              <td class="table-tab__border-right" :rowspan="row.bids.length || 1">
                {{row.name}}
              </td>
              <td class="table-tab__border-right" :rowspan="row.bids.length || 1">
                {{row.initial}}
              </td>
              <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                {{row.organizerDepartment}}
              </td>
              <td class="table-tab__border-right" :rowspan="row.bids.length || 1">
                {{row.organizerFio}}
              </td>
              <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                {{row.method}}
              </td>
              <td class="table-tab__border-right" :rowspan="row.bids.length || 1">
                {{row.tenderNum}}
              </td>
              <td class="table-tab__border-right" :rowspan="row.bids.length || 1">
                {{row.lotNum}}
              </td>
              <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                {{row.numTask}}
              </td>
              <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                {{row.planTenderDays}}
              </td>
              <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                {{row.factTenderDays}}
              </td>
              <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                {{row.planGettingRequestDays}}
              </td>
              <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                {{row.factGettingRequestDays}}
              </td>
              <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                {{row.planProcessingRequestDays}}
              </td>
              <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                {{row.factProcessingRequestDays}}
              </td>
              <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                {{row.planDividingPriceDays}}
              </td>
              <td class="table-tab__border-right  " :rowspan="row.bids.length || 1">
                {{row.factDividingPriceDays}}
              </td>
              <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                -
              </td>
              <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                -
              </td>
            </template>

            <td class="table-tab__border-right ">
              {{bid.winner}}
            </td>
            <td class="table-tab__border-right ">
              {{bid.bid}}
            </td>
            <td>
              {{bid.currency}}
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
    </section>
  </div>
</template>

<script>
  export default {
    props: {
      report: Array
    },

    watch: {
      report() {
      }
    }
  }
</script>

<style scoped>

</style>
